import React, { PropsWithChildren } from 'react'

import styles from './FieldGroup.module.scss'

export const FieldGroup: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>
}
